import React from "react";
import { Row } from "reactstrap";

const Vazia = () => {
  return (
    <>
      <div className="content pb-0">
        <Row className="d-flex justify-content-center">
          <h3>Bem Vindo ao WebGestor!</h3>
        </Row>
      </div>
    </>
  )
}

export default Vazia;